export default __webpack_public_path__ + "static/media/roadmap.e1bdf0b7.png";